import React, { createContext, useReducer, useEffect } from "react";
import useValutationData from '../hooks/useValutationData.ts';
export const ValuationDataContext = createContext();

export const ValuationDataProvider = ({ children }) => {


  const {valuationData, setValuationData, calculateSensitivityAnalysis, calculateNPVtoDiscountRate, isLoading} = useValutationData();

  return (
    <ValuationDataContext.Provider value={{ valuationData, setValuationData, calculateSensitivityAnalysis, calculateNPVtoDiscountRate, isLoading}}>
      {children}
    </ValuationDataContext.Provider>
  );
};
